module.exports = __webpack_public_path__ + "media/images/CHA-09-a74eede6d01f88e26a4fc317e31deeb2.jpg";